import { Node, SimpleNode } from '../../models/models';
import {
    Action,
    ActionWithPayload,
    createAction,
    withMatcher,
} from '../../utils/reducer/reducer.utils';
import { NODE_ACTION_TYPES } from './node.type';

export type GetMyNodesStart = ActionWithPayload<
    NODE_ACTION_TYPES.GET_MY_NODES_START,
    { project: number | null; }
>;

export type GetMyNodesSuccess = ActionWithPayload<
    NODE_ACTION_TYPES.GET_MY_NODES_SUCCESS,
    { myNodes: SimpleNode[]; }
>;

export type GetMyNodesFailed = ActionWithPayload<
    NODE_ACTION_TYPES.GET_MY_NODES_FAILED,
    string
>;

export type GetNodeStart = ActionWithPayload<
    NODE_ACTION_TYPES.GET_NODE_START,
    { nodeId: number; }
>;

export type GetNodeSuccess = ActionWithPayload<
    NODE_ACTION_TYPES.GET_NODE_SUCCESS,
    { nodeSelected: Node; }
>;

export type GetNodeFailed = ActionWithPayload<
    NODE_ACTION_TYPES.GET_NODE_FAILED,
    string
>;

export type ClearNodeSelected = Action<NODE_ACTION_TYPES.CLEAR_NODE_SELECTED>;

export type ChangeNodeStatusStart = ActionWithPayload<
    NODE_ACTION_TYPES.CHANGE_NODE_STATUS_START,
    { nodeId: number; status: string; nextStepsToActivate: number[], onComplete: () => void; }
>;

export type ChangeNodeStatusSuccess = ActionWithPayload<
    NODE_ACTION_TYPES.CHANGE_NODE_STATUS_SUCCESS,
    { nodeId: number; }
>;

export type ChangeNodeStatusFailed = ActionWithPayload<
    NODE_ACTION_TYPES.CHANGE_NODE_STATUS_FAILED,
    string
>;

export const getMyNodesStart = withMatcher(
    (project: number | null): GetMyNodesStart =>
        createAction(NODE_ACTION_TYPES.GET_MY_NODES_START, { project })
);

export const getMyNodesSuccess = withMatcher(
    (myNodes: SimpleNode[]): GetMyNodesSuccess =>
        createAction(NODE_ACTION_TYPES.GET_MY_NODES_SUCCESS, { myNodes })
);

export const getMyNodesFailed = withMatcher(
    (error: string): GetMyNodesFailed =>
        createAction(NODE_ACTION_TYPES.GET_MY_NODES_FAILED, error)
);

export const getNodeStart = withMatcher(
    (nodeId: number): GetNodeStart =>
        createAction(NODE_ACTION_TYPES.GET_NODE_START, { nodeId })
);

export const getNodeSuccess = withMatcher(
    (nodeSelected: Node): GetNodeSuccess =>
        createAction(NODE_ACTION_TYPES.GET_NODE_SUCCESS, { nodeSelected })
);

export const getNodeFailed = withMatcher(
    (error: string): GetNodeFailed =>
        createAction(NODE_ACTION_TYPES.GET_NODE_FAILED, error)
);

export const clearNodeSelected = withMatcher(
    (): ClearNodeSelected => createAction(NODE_ACTION_TYPES.CLEAR_NODE_SELECTED)
);

export const changeNodeStatusStart = withMatcher(
    (
        nodeId: number,
        status: string,
        nextStepsToActivate: number[],
        onComplete: () => void
    ): ChangeNodeStatusStart =>
        createAction(NODE_ACTION_TYPES.CHANGE_NODE_STATUS_START, {
            nodeId,
            status,
            nextStepsToActivate,
            onComplete,
        })
);

export const changeNodeStatusSuccess = withMatcher(
    (nodeId: number): ChangeNodeStatusSuccess =>
        createAction(NODE_ACTION_TYPES.CHANGE_NODE_STATUS_SUCCESS, { nodeId })
);

export const changeNodeStatusFailed = withMatcher(
    (error: string): ChangeNodeStatusFailed =>
        createAction(NODE_ACTION_TYPES.CHANGE_NODE_STATUS_FAILED, error)
);
